import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQ_ITEMS = [
  {
    id: "visum",
    question: "Welches Visum passt zu meiner Auswanderung nach Florida?",
    answer:
      "Das hängt von Ihrer Situation ab – ob Sie ein Unternehmen gründen, investieren oder als Führungskraft wechseln möchten. Neben dem E-2-Visum kommen auch direkte Green-Card-Wege wie EB-2 NIW oder EB-1C infrage. Im kostenlosen Erstgespräch prüfen wir Ihre Ausgangslage und begleiten Ihr gesamtes Verfahren anschliessend persönlich – von der Vorbereitung bis zur Entscheidung.",
  },
  {
    id: "gruendung",
    question: "Kann ich als Deutscher oder Schweizer in Florida eine Firma gründen?",
    answer:
      "Ja. Sie können in Florida eine LLC oder Corporation gründen, auch ohne US-Staatsbürgerschaft oder Green Card. Wir begleiten Sie bei der Wahl der richtigen Unternehmensform, der Registrierung, der Steuernummer (EIN) und der Eröffnung eines Geschäftskontos.",
  },
  {
    id: "ablauf",
    question: "Wie läuft die Zusammenarbeit mit Ihnen ab?",
    answer:
      "Wir starten mit einem kostenlosen Erstgespräch auf Deutsch, in dem wir Ihre Ziele klären. Danach erhalten Sie einen persönlichen Fahrplan für Visum, Unternehmensgründung und Umzug. Wir setzen die Schritte gemeinsam um – vor Ort in Florida und aus Deutschland oder der Schweiz.",
  },
  {
    id: "danach",
    question: "Unterstützen Sie mich auch nach der Auswanderung?",
    answer:
      "Ja. Unsere Betreuung endet nicht am Flughafen: Wir bleiben nach der Auswanderung an Ihrer Seite – bei Fragen zum Unternehmen, zum Alltag in Florida und zu allem, was danach kommt. Persönliche Betreuung auf Deutsch, von der Gründung bis weit nach der Auswanderung.",
  },
  {
    id: "kosten",
    question: "Was kostet die Beratung?",
    answer:
      "Das Erstgespräch ist kostenlos und unverbindlich. Alle weiteren Leistungen besprechen wir transparent und individuell, bevor etwas entsteht – abgestimmt auf Ihr Vorhaben.",
  },
];

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="border-t border-line bg-sand py-24 lg:py-32"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 lg:grid-cols-12 lg:px-10">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6 }}
              className="text-xs uppercase tracking-[0.3em] text-clay"
              data-testid="faq-eyebrow"
            >
              FAQ
            </motion.p>
            <motion.h1
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: 0.1 }}
              className="mt-6 font-serif text-4xl leading-tight tracking-tight text-ink sm:text-5xl"
              data-testid="faq-title"
            >
              Häufige{" "}
              <span className="italic text-clay">Fragen</span>
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: 0.2 }}
              className="mt-6 text-base leading-relaxed text-ink-muted"
              data-testid="faq-intro"
            >
              Antworten auf die Fragen, die uns Deutsche und Schweizer vor der
              Auswanderung nach Florida am häufigsten stellen.
            </motion.p>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="lg:col-span-8"
        >
          <Accordion
            type="single"
            collapsible
            className="border-t border-line"
            data-testid="faq-accordion"
          >
            {FAQ_ITEMS.map((item) => (
              <AccordionItem
                key={item.id}
                value={item.id}
                className="border-b border-line"
                data-testid={`faq-item-${item.id}`}
              >
                <AccordionTrigger
                  className="py-6 text-left font-serif text-xl tracking-tight text-ink hover:text-clay hover:no-underline sm:text-2xl"
                  data-testid={`faq-trigger-${item.id}`}
                >
                  {item.question}
                </AccordionTrigger>
                <AccordionContent
                  className="max-w-2xl pb-8 text-sm leading-relaxed text-ink-muted md:text-base"
                  data-testid={`faq-content-${item.id}`}
                >
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
